require('bootstrap-select/js/bootstrap-select');
require('bootstrap-slider/dist/bootstrap-slider');
require('lightgallery/dist/js/lightgallery');
require('lightgallery/modules/lg-video');
import Swiper from 'swiper/bundle';

let window_w = 0;
let height_w = 0;
let window_w_2 = 0;
/*
function getCookie(name) {
    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, props) {
    props = props || {};
    var exp = props.expires;
    if (typeof exp == "number" && exp) {
        var d = new Date();
        d.setTime(d.getTime() + exp * 1000);
        exp = props.expires = d;
    }
    if (exp && exp.toUTCString) {
        props.expires = exp.toUTCString();
    }

    value = encodeURIComponent(value);
    var updatedCookie = name + "=" + value;
    for (var propName in props) {
        updatedCookie += "; " + propName;
        var propValue = props[propName];
        if (propValue !== true) {
            updatedCookie += "=" + propValue;
        }
    }
    document.cookie = updatedCookie;
}
*/
$(() => {

    window_w = $(window).width();
    height_w = $(window).height();
    window_w_2 = $(window).width();

    new WOW().init();

    /* setTimeout(function(){
         var terms = getCookie('cookies__accept');
         // console.log(terms);

         if (!terms) {
             $('.cookies__block').fadeIn(300);
         }

     }, 1000); */

    $('.cookies__accept').on('click', function (e) {
        e.preventDefault();
        setCookie('cookies__accept', true, {expires: 2592000, SameSite: "None"});
        $('.cookies__block').fadeOut(300);
    });

    $('.cookies__block .close').on('click', function () {
        $('.cookies__block').fadeOut(300);
    });

    //------------------------------------------------------------------------------------------------------------------
    //------------- Switcher

    $('.picker__dropdown .picker__lable').on('click', function (e) {
        e.preventDefault();
        if ($(this).parent().hasClass('dropdown_open')) {
            $(this).parent().removeClass('dropdown_open');
            $(this).parent().find('.picker__list').fadeOut(300);
            $(this).parent().find('.picker__list_overlay').removeAttr('style');
            if ($(this).parents('.header__account_menu').length) {
                $('body').removeClass('body__overlay');
            }
        } else {
            $(this).parent().addClass('dropdown_open');
            $(this).parent().find('.picker__list').fadeIn(300);
            $(this).parent().find('.picker__list_overlay').css('display', 'flex');

            console.log($(this).parents('.header__account_menu').length);
            if ($(this).parents('.header__account_menu').length) {
                $('body').addClass('body__overlay');
            }
        }
    })

    $('.picker__dropdown_select .picker__item').on('click', function (e) {
        e.preventDefault();

        var text = $(this).find('a').text();

        $('.picker__dropdown_select .picker__item').removeClass('current');
        $(this).addClass('current');
        $(this).parents('.picker__dropdown_select').find('.picker__lable').text(text);

        $(this).parents('.picker__dropdown_select').removeClass('dropdown_open');
        $(this).parents('.picker__dropdown_select').find('.picker__list').fadeOut(300);
    })

    $('.picker__list_overlay').on('click', function (e) {
        $(this).removeAttr('style');
        $(this).parent().removeClass('dropdown_open');
        $(this).parent().find('.picker__list').fadeOut(300);
        e.preventDefault();
    });

    $('.picker__list_overlay .picker__list').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
    });


    //------------- End Switcher
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Sliders

    let main__slider = new Swiper('.main__slider', {
        // allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        pagination: {
            el: '.main__slider-pagination',
            clickable: true,
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    if ($('.shops__slider').length) {

        let shops__slider = new Swiper('.shops__slider', {
            slidesPerView: 'auto',
            spaceBetween: 16,
            // autoHeight: true,
            watchOverflow: true,

            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                },
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            pagination: {
                el: '.shops__slider-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    if ($('.products__slider').length) {

        let products__slider = new Swiper('.products__slider', {
            slidesPerView: 'auto',
            spaceBetween: 24,
            // autoHeight: true,
            watchOverflow: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            pagination: {
                el: '.products__slider-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    //------------- End Sliders
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Mobile menu trigger

    $('.header__menu_trigger').on('click', function (e) {
        $('.header__mobile_block').addClass('open');
        $('html').addClass('modal-open');
        e.preventDefault();
    });

    $('.header__mobile_close').on('click', function (e) {
        $('.header__mobile_block').removeClass('open');
        $('html').removeClass('modal-open');
        e.preventDefault();
    });

    //------------- End Mobile menu trigger
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Video

    $('.slide__block').lightGallery({
        selector: '.play__video',
        counter: false,
        videoMaxWidth: '1200px'
    });

    //------------- End Video
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Quantity (+/-)

    let delay = (function () {
        var timer = 0;
        return function (callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        };
    })();
/*
    var customNumberInput = function customNumberInput() {
        $('.input_quantity:not(.no-controls)').each(function () {
            var $this = $(this);

            if ($this.parent().is('.block__input_quantity')) {
                return;
            }

            $this.wrap('<div class="block__input_quantity"></div>');
            $this.before('<button class="js-minus"></button>');
            $this.after('<button class="js-plus"></button>');

            $this.on('change keyup', function (e) {
                e.preventDefault();
                var $input = $(this);
                var value = parseInt($input.val());

                delay(function(){
                    if (value < 1 || $input.val() === "") {
                        value = 1;
                    } else if (value > 999) {
                        value = 999;
                    }

                    $input.val(value);

                }, 500 );
            });
        });

        $('.js-plus').unbind().click(function (e) {
            var _this = this;
            e.preventDefault();
            var $input = $(this).siblings('input');
            var id = $input.attr('data-id');
            var url = $input.attr('data-url');
            var value = parseInt($input.val()) + 1;

            if (value < 1 || $input.val() === "") {
                value = 1;
            } else if (value > 999) {
                value = 999;
            }

            $input.val(value);

        });
        $('.js-minus').unbind().click(function (e) {
            var _this2 = this;

            e.preventDefault();
            var $input = $(this).siblings('input');
            var id = $input.attr('data-id');
            var url = $input.attr('data-url');
            var min = 1;

            if ($input.attr('min')) {
                min = $input.attr('min');
            }
            var value = Math.max(parseInt($input.val()) - 1, min);

            if (value < 1 || $input.val() === "") {
                value = 1;
            } else if (value > 999) {
                value = 999;
            }

            $input.val(value);
        });

    };
    customNumberInput();
    */

    //------------- End Quantity (+/-)
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Copy track number

    $('.copy__traking_number').on('click', function (e) {
        e.preventDefault();

        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val($('.order__traking_number').text()).select();
        document.execCommand("copy");
        $temp.remove();
        console.log('copied to clipboard');
    });

    //------------- End Copy track number
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Copy to clipboard

    $(".form__col_copy").hover(function () {
        $(this).find('.copy__input_icon').stop().fadeIn(300);
    }, function () {
        $(this).find('.copy__input_icon').stop().fadeOut(300);
    });


    $('.copy__input_icon').on('click', function (e) {
        e.preventDefault();
        let copyText = $(this).prev();
        let copyAlert = $(this).next();

        copyText.select();
        document.execCommand("copy");

        copyAlert.fadeIn(300);

        setTimeout(function () {
            copyAlert.fadeOut(300);
        }, 1000);

    });


    $('.copy__traking_number').on('click', function (e) {
        e.preventDefault();
        let copyText = $('.order__traking_number');
        let copyAlert = $('.copy__traking_alert');


        copyText.select();
        document.execCommand("copy");

        copyAlert.fadeIn(300);

        setTimeout(function () {
            copyAlert.fadeOut(300);
        }, 1000);

    });


    //------------- End Copy to clipboard
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Select all

  /*  $('[name="select_all"]').on('change', function (e) {
        $(this).parents('.table').find('.checkbox__custom label').click();
    }); */

    //------------- End Select all
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Modal block

    $('.modal__trigger').on('click', function (e) {
        if ($(this).hasClass('modal_open')) {
            $(this).removeClass('modal_open');
            $(this).parent().find('.modal__content').fadeOut(300);
        } else {
            $(this).addClass('modal_open');
            $(this).parent().find('.modal__content').fadeIn(300);
            $(this).remove();
        }
        e.preventDefault();
    });

    //------------- End Modal block
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Calculator
    /*
        let weight_calc = $("#weight_calc").slider();

        weight_calc.on("slide", function(slideEvt) {
            $("#weight_calc_value").val(slideEvt.value);
        });

        $("#weight_calc_value").on("keyup", function (e) {

            let min = weight_calc.slider('getAttribute', 'min');
            let max = weight_calc.slider('getAttribute', 'max');

            let value = $(this).val();

            if (value < min) {
                value = min
                $(this).val(min);
            } else if(value > max) {
                value = max
                $(this).val(max);
            }

            weight_calc.slider('setValue', value);

        });
    */
    //------------- End Calculator
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Shop steps img zoom

    $('.section__simple_block ').lightGallery({
        selector: '.lightgallery',
    });

    //------------- End Shop steps img zoom
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Open/Close mobile account block

    $('.account__block_trigger').on('click', function (e) {
        $(this).parent().toggleClass('open');
        e.preventDefault();
    });

    //------------- End Open/Close mobile account block
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Filter

    $('.filter__block_trigger').on('click', function (e) {
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $('.filter__block_cotent').slideUp(300);
        } else {
            $(this).addClass('open');
            $('.filter__block_cotent').slideDown(300);
        }
    });

    //------------- End Filter
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Breadcrumbs width

    var sum = 0;

    if ($('.breadcrumbs__block').length) {
        $('.breadcrumbs__block li').each(function () {
            var width = $(this).innerWidth();
            var count = $(this).parent().find('li').length;

            // width += 30;
            sum += width;

            $('.breadcrumbs__block ul').css('min-width', sum + count);
        });
    }

    //------------- End Breadcrumbs width
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Sidebar menu mobile open/close

    $('.sidebar__menu .current').on('click', function (e) {
        if (window_w <= 992) {
            if ($(this).parents('.sidebar__menu').hasClass('open')) {
                $(this).parents('.sidebar__menu').removeClass('open');
                $(this).parents('.sidebar__menu').height(24);
            } else {
                let height = $(this).parents('.sidebar__menu').find('ul').innerHeight();
                $(this).parents('.sidebar__menu').addClass('open');
                $(this).parents('.sidebar__menu').height(height);
            }
        }
        e.preventDefault();
    });

    $(window).resize(function () {
        window_w = $(window).width();
        if (window_w != window_w_2) {
            if (window_w >= 992) {
                $('.sidebar__menu').removeAttr('style');
            }
            window_w_2 = $(window).width();
        }
    });

    //------------- End Sidebar menu mobile open/close
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Custom select

    if ($('.selectpicker').length) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
            $('.form__col > .selectpicker').selectpicker('mobile');
        }
    }

    //------------- End Custom select
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- Tooltips

    $('.tooltip__block_trigger').on('click', function (e) {
        if (window_w <= 1200) {
            $('.tooltip__block_inner').hide();
            $(this).next().toggle();
            e.preventDefault();
        }
    });

    $('.tooltip__modal .tooltip__block_trigger').on('click', function (e) {
        if (window_w <= 1200) {
            $('.tooltip__block_inner').removeAttr('style');

            $('.with__line').addClass('hide');

            $(this).next('.tooltip__block_overlay').css('display', 'flex');
            $(this).parent().find('.tooltip__block_inner').fadeIn(300);
            e.preventDefault();
        }
    });

    $('.tooltip__block_overlay').on('click', function (e) {
        $(this).removeAttr('style');
        $('.with__line').removeClass('hide');
        $(this).parent().find('.tooltip__block_inner').removeAttr('style');
        e.preventDefault();
    });

    $('.tooltip__block_close').on('click', function (e) {
        $(this).parents('.tooltip__block_overlay').removeAttr('style');
        $('.with__line').removeClass('hide');
        $(this).parents('.tooltip__modal').find('.tooltip__block_inner').removeAttr('style');
        e.preventDefault();
    });


    $('.tooltip__block_inner').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
    });

    //------------- End Tooltips
    //------------------------------------------------------------------------------------------------------------------


    //------------------------------------------------------------------------------------------------------------------
    //------------- input filter


    // Restricts input for the given textbox to the given inputFilter.
 /*   $.fn.inputFilter = function (inputFilter) {
        return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            } else {
                this.value = "";
            }
        });
    };

    $('.type_tel').inputFilter(function (value) {
        return /^\d*$/.test(value);
        // Allow digits only, using a RegExp Integer >= 0
    });
    $('.type_float').inputFilter(function (value) {
        return /^-?\d*[.,]?\d*$/.test(value);
        // Allow digits only, using a RegExp Float (use . or , as decimal separator)
    });

  */

    //------------- End input filter
    //------------------------------------------------------------------------------------------------------------------


});


//------------------------------------------------------------------------------------------------------------------
//------------- Outside click

$(document).click(function (e) {
    // if ( $( e.target ).closest( '.simple__block_modal' ).length )
    //     return;
    // $( '.modal__trigger' ).removeClass( 'modal_open' );
    // $('.modal__content').fadeOut(300);


    if ($(e.target).closest('.picker__dropdown').length)
        return;
    $('.picker__dropdown').removeClass('dropdown_open');
    $('body').removeClass('body__overlay');
    $('.picker__list').fadeOut(300);


    if (window_w < 1200) {
        if ($(e.target).closest('.tooltip__block_simple').length)
            return;
        $('.tooltip__block_simple .tooltip__block_inner').removeAttr('style');
    }

    if (window_w < 992) {
        if ($(e.target).closest('.sidebar__menu').length)
            return;
        $('.sidebar__menu').removeClass('open');
        $('.sidebar__menu').height(24);
    }

    e.stopPropagation();
});


//------------- End Outside click
//------------------------------------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------------------------------------
//------------- press Esc

$(document).on('keyup', function (e) {
    if (e.keyCode === 27) {
        if ($('.picker__dropdown').hasClass('dropdown_open')) {
            $('.picker__dropdown').removeClass('dropdown_open');
            $('body').removeClass('body__overlay');
            $('.picker__list').fadeOut(300);
        }

        // if ( $( '.modal__trigger' ).hasClass( 'modal_open' ) ) {
        //     $( '.modal__trigger' ).removeClass( 'modal_open' );
        //     $('.modal__content').fadeOut(300);
        // }

        if ($('.sidebar__menu').hasClass('open')) {
            if (window_w < 992) {
                $('.sidebar__menu').removeClass('open');
                $('.sidebar__menu').height(24);
            }
        }
    }
});

//------------- End press Esc
//------------------------------------------------------------------------------------------------------------------
window.addEventListener('load', function () {
    const elements = document.getElementsByClassName("loading__block");
    for (const element of elements) {
        //console.log('fakeImage: ', element);
        if (typeof (element) != 'undefined' && element != null) {

            setTimeout(function () {
                element.classList.add('animate');
            }, 1000);
        }
    }
});
